<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2024-08-27 18:33:39
-->
<template>
  <role-home-page
    :customeRoadMap="['首页']"
    :initHook="init"
    :destryHook="destroy"
  >
  </role-home-page>
</template>

<script>
import RoleHomePage from "../home/roleHomeBase.vue";
export default {
  components: {
    RoleHomePage,
  },
  methods: {
    init() {},
    destroy() {},
  },
};
</script>

<style>
</style>